import axios from 'axios'
import { FilterQuery } from '../definition'
import {
  ListNoteTopicResponseDto,
  NewNoteDto,
  NewNoteTopicDto,
  MiscNoteDto,
  NoteTopicDto,
  UpdateNoteDto
} from '../definition/notes.dto'
import { ENV } from '../initialization'

const DOMAIN = ENV.BACKEND_PREFIX_URL

export const asyncGetListNoteTopic = async (data?: FilterQuery): Promise<ListNoteTopicResponseDto | undefined> => {
  const url = `${DOMAIN}/api/booking/booking/misc-note/topic/list`
  const response = await axios.get<ListNoteTopicResponseDto>(url, {
    params: data
  })
  return response.data
}

export const asyncGetMiscNote = async (id: string): Promise<MiscNoteDto | undefined> => {
  const url = `${DOMAIN}/api/booking/booking/misc-note/${id}`
  const response = await axios.get<MiscNoteDto>(url)
  return response.data
}

export const asyncCreateNote = async (data: NewNoteDto): Promise<MiscNoteDto | undefined> => {
  const url = `${DOMAIN}/api/booking/booking/misc-note/create`
  const response = await axios.post(url, data)
  return response.data
}

export const asyncUpdateNote = async (id: string, data: UpdateNoteDto): Promise<void> => {
  const url = `${DOMAIN}/api/booking/booking/misc-note/update/${id}`
  const response = await axios.put(url, data)
  return response.data
}

export const asyncCreateTopic = async (data: NewNoteTopicDto): Promise<NoteTopicDto | undefined> => {
  const url = `${DOMAIN}/api/booking/booking/misc-note/topic/create`
  const response = await axios.post(url, data)
  return response.data
}

export const asyncSaveTopic = async (updatedDto: NoteTopicDto): Promise<void> => {
  const url = `${DOMAIN}/api/booking/booking/misc-note/topic/update/${updatedDto.id}`
  await axios.put(url, updatedDto)
}

export const asyncDeleteNoteTopic = async (id: string): Promise<void> => {
  const url = `${DOMAIN}/api/booking/booking/misc-note/topic/delete/${id}`
  await axios.delete(url)
}
